import React, { useState, useEffect } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [text, setText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const fullText = "Farmnet is an amazing app—it automatically generates reports for you, making farm management so much easier.";

  useEffect(() => {
    let currentIndex = 0;
    let typingInterval;

    const typeText = () => {
      if (currentIndex < fullText.length) {
        setText(fullText.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        // Pause at the end before starting over
        clearInterval(typingInterval);
        setTimeout(() => {
          setIsTyping(false);
          setTimeout(() => {
            backspaceText();
          }, 2000);
        }, 1000);
      }
    };

    const backspaceText = () => {
      let backspaceInterval;
      let backspaceIndex = fullText.length;

      const eraseText = () => {
        if (backspaceIndex >= 0) {
          setText(fullText.substring(0, backspaceIndex));
          backspaceIndex--;
        } else {
          clearInterval(backspaceInterval);
          setIsTyping(true);
          currentIndex = 0;
          typingInterval = setInterval(typeText, 50); // Start typing again
        }
      };

      backspaceInterval = setInterval(eraseText, 20);
    };

    if (isTyping) {
      typingInterval = setInterval(typeText, 50);
    }

    return () => {
      clearInterval(typingInterval);
    };
  }, [isTyping, fullText]);

  return (
    <div className="relative bg-[#F3F3F3]">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-24 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 flex justify-between items-center">
          <h1 className="text-[12px] md:text-[36px] font-bold md:mb-3">
             <span className='text-[#152C24]'>VOICE OF FARMERS</span>
          </h1>
          <div>
            <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
              <div className='bg-[#CFD7D7] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751045210/Expand_left_light_scmuqw.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
              <div className="bg-[#2E453D] border-b-2 border-[#FFBD26] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[20px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
                See More
              </div>
              <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
                  alt="Arrow"
                  className="w-2 h-2 mt-1 md:hidden flex"
                /> 
              </div>
            </div>
          </div>
        </div>

        {/* Records Section */}
        <div className="rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center md:p-0 pt-2 md:mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[180px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            {showVideo ? (
              <div className="w-full h-full">
                <video
                  src="https://res.cloudinary.com/dzngpgki4/video/upload/v1751041803/Voice_of_Farmer_5_d5pfw0.mp4"
                  controls
                  autoPlay
                  className="w-full h-full object-cover"
                />
               
                <img
                  onClick={() => setShowVideo(false)}
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751046974/close_ring_duotone_ralxeq.png"
                  alt="Arrow"
                  className=" absolute top-2 right-2 md:w-16 md:h-16 w-2 h-2 mt-1 "
                /> 
              </div>
            ) : (
              <>
                <img
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751371346/image_zgzjva.png"
                  alt="Mobile"
                  className="object-cover w-full h-full"
                />
                {/* Play Icon */}
                <div
                  onClick={() => setShowVideo(true)}
                  className="absolute inset-0 flex justify-center items-center cursor-pointer"
                >
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                    alt="Play Icon"
                    className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-4 space-y-6'>
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#979797] md:mb-3">
            SOLUTION | <span className='text-[#152C24]'>REPORT</span>
          </h1>

          <div className="space-y-2 sm:space-y-1">
            <p className="md:text-[32px] text-[8px]">The reports solution allows users to generate and view detailed reports on various aspects of their farming activities.  <br/>
            These reports may include data on crop performance, input usage, weather impacts, market trends, service usage, and income tracking. .</p>
          </div>
          <p className="md:text-[32px] text-[8px] md:mt-8 mt-3">By analyzing these reports, farmers can monitor progress, evaluate outcomes, identify challenges, and make informed decisions to improve productivity and profitability over timey.</p>
        </div>
        
        {/* Animated Quote Box */}
        <div className='bg-white w-full md:mt-8 mt-3 md:h-[230px] h-[80px] border-[1px] rounded-r-[75px] rounded-tl-[75px] flex justify-center items-center text-center border-[#C4C4C4]'>  
          <div>
            <h1 className="text-[12px] md:text-[28px] font-bold italic text-black">
              {text}
              <span className="animate-pulse">|</span>
            </h1>
          </div>
        </div>
        
        <h1 className='md:mt-8 mt-4 font-normal italic md:text-[32px] text-[10px]'>Farmer , Mpumalanga South Africa</h1>
        <div className='flex justify-end items-center'>
          <div>
            <h1 className="text-[18px] md:text-[32px] font-bold mt-2 mb-4 text-black">
              Download App
            </h1>
            <div className="md:w-[450px]">
              <div className="flex flex-row justify-between space-x-2 items-center sm:space-y-0">
                <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">   
             <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />    
             <p className="md:text-[14px] text-[6px] md:-mt-12 md:pl-5 font-normal md:px-1">
             Click to download App
  </p>
     </a>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
                  alt="Google Play"
                  className="h-[30px] md:h-[75px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <div className='md:h-10 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;